import { produce } from "immer";
import {
  FETCH_SLICK_CARE_PROFILES,
  FETCH_SLICK_CARE_PROFILES_SUCCESS,
  FETCH_SLICK_CARE_PROFILES_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_SLICK_CARE_PROFILES,
  ADD_SLICK_CARE_PROFILES_SUCCESS,
  ADD_SLICK_CARE_PROFILES_FAILURE,
  //
  EDIT_SLICK_CARE_PROFILES,
  EDIT_SLICK_CARE_PROFILES_SUCCESS,
  EDIT_SLICK_CARE_PROFILES_FAILURE,
  //
  DELETE_SLICK_CARE_PROFILES,
  DELETE_SLICK_CARE_PROFILES_SUCCESS,
  DELETE_SLICK_CARE_PROFILES_FAILURE,
  //
  SEARCH_SLICK_CARE_PROFILES,
  SEARCH_SLICK_CARE_PROFILES_FAILURE,
  SEARCH_SLICK_CARE_PROFILES_SUCCESS,
  //
  OPEN_WEBSITE_MODAL,
  CLOSE_WEBSITE_MODAL,
  //
  OPEN_ROOM_ADD_MODAL,
  CLOSE_ROOM_ADD_MODAL,
  //
  ADD_ROOM,
  ADD_ROOM_FAILURE,
  ADD_ROOM_SUCCESS,
  //
  FETCH_ROOMS,
  FETCH_ROOMS_FAILURE,
  FETCH_ROOMS_SUCCESS,
  //
  FETCH_ALL_LOCATION,
  FETCH_ALL_LOCATION_SUCCESS,
  FETCH_ALL_LOCATION_FAILURE,
  //
  OPEN_VIEW_ROOMS_MODAL,
  CLOSE_VIEW_ROOMS_MODAL,
  //
  FETCH_ALL_ROOMS,
  FETCH_ALL_ROOMS_SUCCESS,
  FETCH_ALL_ROOMS_FAILURE,
  //
  DELETE_CARE_ROOM,
  DELETE_CARE_ROOM_SUCCESS,
  DELETE_CARE_ROOM_FAILURE,
  //
  GET_CARE_ROOM_DATA,
  GET_CARE_ROOM_DATA_SUCCESS,
  GET_CARE_ROOM_DATA_FAILURE,
  //
  EDIT_CARE_ROOM,
  EDIT_CARE_ROOM_SUCCESS,
  EDIT_CARE_ROOM_FAILURE,
  //
  OPEN_INVITE_MODAL,
  CLOSE_INVITE_MODAL,
  //
  INVITE_STAFF,
  INVITE_STAFF_SUCCESS,
  INVITE_STAFF_FAILURE,
  //
  OPEN_COMPANY_MODAL,
  CLOSE_COMPANY_MODAL,
  //
  SEARCH_COMPANY,
  SEARCH_COMPANY_SUCCESS,
  SEARCH_COMPANY_FAILURE,
  //
  CHANGE_COMPANY,
  CHANGE_COMPANY_SUCCESS,
  CHANGE_COMPANY_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingSlickCareProfiles: false,
  SlickCareProfiles: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentSlickCareProfiles: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  //
  websiteModalOpen: false,
  websiteModalData: {},
  //
  isRoomAddModalOpen: false,
  isFetchingRooms: false,
  Rooms: [],
  //
  fetchingAllLocation: false,
  allLocations: [],
  //
  isViewRoomsModalOpen: false,
  //
  isFetchingAllRooms: false,
  isDeletingCareRoom: false,
  isFetchingCareRoom: false,
  isEditingCareRoom: false,
  allRooms: [],
  currentCareRoom: {},
  isInviteModalOpen: {
    location_id: "",
    open: false,
  },
  isInvitingStaff: {
    location_id: "",
    open: false,
  },
  companyModal: {
    open: false,
    location_id: "",
  },
  isChangingCompany: false,
  isSearchingCompany: false,
};

const SlickCareProfilesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_SLICK_CARE_PROFILES:
        draft.isFetchingSlickCareProfiles = true;
        draft.currentSlickCareProfiles = {};
        break;
      case FETCH_SLICK_CARE_PROFILES_SUCCESS:
        draft.isFetchingSlickCareProfiles = false;
        draft.SlickCareProfiles = action.payload;
        break;
      case FETCH_SLICK_CARE_PROFILES_FAILURE:
        draft.isFetchingSlickCareProfiles = false;
        break;
      // Search List
      case SEARCH_SLICK_CARE_PROFILES:
        draft.isFetchingSlickCareProfiles = true;
        draft.currentSlickCareProfiles = {};
        break;
      case SEARCH_SLICK_CARE_PROFILES_SUCCESS:
        draft.isFetchingSlickCareProfiles = false;
        draft.SlickCareProfiles = action.payload;
        break;
      case SEARCH_SLICK_CARE_PROFILES_FAILURE:
        draft.isFetchingSlickCareProfiles = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentSlickCareProfiles = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentSlickCareProfiles = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_SLICK_CARE_PROFILES:
        draft.isSubmitting = true;
        break;
      case ADD_SLICK_CARE_PROFILES_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_SLICK_CARE_PROFILES_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_SLICK_CARE_PROFILES:
        draft.isSubmitting = true;
        break;
      case EDIT_SLICK_CARE_PROFILES_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_SLICK_CARE_PROFILES_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_SLICK_CARE_PROFILES:
        draft.isDeleting = true;
        break;
      case DELETE_SLICK_CARE_PROFILES_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_SLICK_CARE_PROFILES_FAILURE:
        draft.isDeleting = false;
        break;

      case OPEN_WEBSITE_MODAL:
        draft.websiteModalOpen = true;
        draft.websiteModalData = action.payload;
        break;
      case CLOSE_WEBSITE_MODAL:
        draft.websiteModalOpen = false;
        draft.websiteModalData = {};
        break;
      // NOTE OPEN
      case OPEN_ROOM_ADD_MODAL:
        draft.isRoomAddModalOpen = true;
        break;
      case CLOSE_ROOM_ADD_MODAL:
        draft.isRoomAddModalOpen = false;
        break;
      // Add
      case ADD_ROOM:
        draft.isSubmitting = true;
        break;
      case ADD_ROOM_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_ROOM_FAILURE:
        draft.isSubmitting = false;
        break;
      // List
      case FETCH_ROOMS:
        draft.isFetchingRooms = true;
        break;
      case FETCH_ROOMS_SUCCESS:
        draft.isFetchingRooms = false;
        draft.Rooms = action.payload;
        break;
      case FETCH_ROOMS_FAILURE:
        draft.isFetchingRooms = false;
        break;

      case FETCH_ALL_LOCATION:
        draft.fetchingAllLocation = true;
        draft.allLocations = [];
        break;
      case FETCH_ALL_LOCATION_SUCCESS:
        draft.fetchingAllLocation = false;
        draft.allLocations = action.payload;
        break;
      case FETCH_ALL_LOCATION_FAILURE:
        draft.fetchingAllLocation = false;
        draft.allLocations = [];
        break;

      case OPEN_VIEW_ROOMS_MODAL:
        draft.isViewRoomsModalOpen = true;
        break;
      case CLOSE_VIEW_ROOMS_MODAL:
        draft.isViewRoomsModalOpen = false;
        break;

      case FETCH_ALL_ROOMS:
        draft.isFetchingAllRooms = true;
        draft.allRooms = [];
        break;
      case FETCH_ALL_ROOMS_SUCCESS:
        draft.isFetchingAllRooms = false;
        draft.allRooms = action.payload;
        break;
      case FETCH_ALL_ROOMS_FAILURE:
        draft.isFetchingAllRooms = false;
        draft.allRooms = [];
        break;

      case DELETE_CARE_ROOM:
        draft.isDeletingCareRoom = true;
        break;
      case DELETE_CARE_ROOM_SUCCESS:
        draft.isDeletingCareRoom = false;
        break;
      case DELETE_CARE_ROOM_FAILURE:
        draft.isDeletingCareRoom = false;
        break;

      case GET_CARE_ROOM_DATA:
        draft.isFetchingCareRoom = true;
        draft.currentCareRoom = {};
        break;
      case GET_CARE_ROOM_DATA_SUCCESS:
        draft.isFetchingCareRoom = false;
        draft.currentCareRoom = action.payload;
        break;
      case GET_CARE_ROOM_DATA_FAILURE:
        draft.isFetchingCareRoom = false;
        draft.currentCareRoom = {};
        break;

      case EDIT_CARE_ROOM:
        draft.isEditingCareRoom = true;
        break;
      case EDIT_CARE_ROOM_SUCCESS:
        draft.isEditingCareRoom = false;
        break;
      case EDIT_CARE_ROOM_FAILURE:
        draft.isEditingCareRoom = false;
        break;

      case OPEN_INVITE_MODAL:
        draft.isInviteModalOpen = action.payload;
        break;
      case CLOSE_INVITE_MODAL:
        draft.isInviteModalOpen = action.payload;
        break;

      case INVITE_STAFF:
        draft.isInvitingStaff = true;
        break;
      case INVITE_STAFF_SUCCESS:
        draft.isInvitingStaff = false;
        draft.isInviteModalOpen = { open: false, location_id: "" };
        break;
      case INVITE_STAFF_FAILURE:
        draft.isInvitingStaff = false;
        break;

      case OPEN_COMPANY_MODAL:
        draft.companyModal = {
          open: action.payload.open,
          location_id: action.payload.location_id,
        };
        break;
      case CLOSE_COMPANY_MODAL:
        draft.companyModal = { open: false, location_id: "" };
        break;

      case SEARCH_COMPANY:
        draft.isSearchingCompany = true;
        draft.companyList = [];
        break;
      case SEARCH_COMPANY_SUCCESS:
        draft.isSearchingCompany = false;
        draft.companyList = action.payload;
        break;
      case SEARCH_COMPANY_FAILURE:
        draft.isSearchingCompany = false;
        draft.companyList = [];
        break;

      case CHANGE_COMPANY:
        draft.isChangingCompany = true;
        break;
      case CHANGE_COMPANY_SUCCESS:
        draft.isChangingCompany = false;
        break;
      case CHANGE_COMPANY_FAILURE:
        draft.isChangingCompany = false;
        break;

      default:
        return state;
    }
  });

export default SlickCareProfilesReducer;
